const defaultState = {
  totalCount: 0,
  packages: [],
  isFetching: false,
};

function chargerPackages(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'SET_PACKAGES':
      return { ...state, packages: action.packages };
    case 'SET_TOTAL_COUNT':
      return { ...state, totalCount: action.totalCount };
    case 'TOGGLE_PACKAGES_FETCHING':
      return { ...state, isFetching: action.flag };
    default:
      return state;
  }
}

export default chargerPackages;
